import { useLocation } from 'react-router-dom';
import React, { createContext, useContext, useEffect } from 'react';

export const PathnameContext = createContext({});

/**
 * @NOTES
 *
 * This hook is responsible for monitoring user navigation between project modules
 * and managing the cleaning of sessionStorage, to prevent search filters from modules
 * that use the dropdownDatatable component from persisting.
 *
 */

function PathnameProvider({ children }) {
  const location = useLocation();

  function checkIfIsEditPage(path) {
    const hasEditPath = path.find(
      (item) => item === 'edit' || item === 'editar'
    );

    const lastItem = path[path.length - 1];
    const isLastItemNumber = !isNaN(lastItem);

    return hasEditPath || isLastItemNumber;
  }

  useEffect(() => {
    const pathnameSegments = location.pathname.split('/');
    const lastSegment = pathnameSegments[pathnameSegments.length - 1];

    // This dynamic assignment handles the maintenance of sessionStorage even in modules
    // that are within modules, that is, it has more than 3 segments in its url.
    let currentModule =
      pathnameSegments.length >= 3 ? lastSegment : pathnameSegments[1];

    const previousModule = sessionStorage.getItem('currentModule');

    if (
      previousModule !== currentModule &&
      !checkIfIsEditPage(pathnameSegments)
    ) {
      sessionStorage.removeItem('search');
      sessionStorage.removeItem('searchGroup');
      sessionStorage.removeItem('currentPage');
      sessionStorage.removeItem('currentPageRemote');
      sessionStorage.removeItem('filtersCredentialsNT');
    }

    !checkIfIsEditPage(pathnameSegments) &&
      sessionStorage.setItem('currentModule', currentModule);
  }, [location.pathname]);

  return (
    <PathnameContext.Provider value={{}}>{children}</PathnameContext.Provider>
  );
}

function usePathname() {
  const context = useContext(PathnameContext);

  return context;
}

export { PathnameProvider, usePathname };
